import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconSearchComponent } from "./med-icon-search.component";

@NgModule({
  declarations: [
    MedIconSearchComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconSearchComponent,
  ],
})
export class MedIconSearchModule { }
